<template>
    <auth-layout>
        <header-page title="Help" />
        <loading-block v-if="loading" />
        <div class="mt-5 p-2" v-else>
            <div class="wrap-button-ticket">
                <div>
                    <div class="open-ticket-wrap">
                        <button class="btn btn-primary" @click="openModal">Open Ticket</button>
                    </div>
                </div>
                <div>
                    <search-article @search="searchArticle" :expand="false" :query="search"/>
                </div>
            </div>
            <table class="table bg-white ticket-table">
                <thead>
                    <tr>
                        <th scope="col">No</th>
                        <th scope="col">Status</th>
                        <th scope="col">Last Updated</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="item in data.data" v-bind:key="item._id">
                        <th scope="row"><router-link :to="{ name: 'help-show', params: { id: item._id } }">{{item.no}}</router-link></th>
                        <td>{{item.status === 1 ? 'Open' : 'Close'}}</td>
                        <td>{{moment(item.updated_at)}}</td>
                    </tr>
                </tbody>
            </table>
            <div class="d-flex mt-5">
                <div class="mx-auto">
                    <pagination :data="data" @pagination-change-page="getData" :limit="1"></pagination>
                </div>
            </div>
        </div>
        <!-- Modal -->
        <div class="modal fade" id="sendModal" tabindex="-1" role="dialog" aria-labelledby="sendModalLabel" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="sendModalLabel">Keluhan Baru</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <loading-block v-if="sendLoading" />
                        <div v-else>
                            <div class="form-group">
                                <label for="destination">Bagian yang dituju</label>
                                <select class="form-control clean-form" v-bind:class="errors.hasOwnProperty('destination') ? 'is-invalid' : ''" id="destination" v-model="form.destination">
                                    <option></option>
                                    <option v-for="item in destinations" :value="item.id" v-bind:key="item.id">{{ item.title }}</option>
                                </select>
                                <div class="invalid-feedback" v-if="errors.hasOwnProperty('destination')">
                                    {{ errors['destination'][0] }}
                                </div>
                            </div>
                            <div class="form-group">
                                <label for="title">Topik</label>
                                <input class="form-control" v-model="form.title" id="title" v-bind:class="errors.hasOwnProperty('title') ? 'is-invalid' : ''">
                                <div class="invalid-feedback" v-if="errors.hasOwnProperty('title')">
                                    {{ errors['title'][0] }}
                                </div>
                            </div>
                            <div class="form-group">
                                <label for="message">Keluhan</label>
                                <textarea class="form-control" id="message" rows="3" v-model="form.message" v-bind:class="errors.hasOwnProperty('message') ? 'is-invalid' : ''"></textarea>
                                <div class="invalid-feedback" v-if="errors.hasOwnProperty('message')">
                                    {{ errors['message'][0] }}
                                </div>
                            </div>
                            <div class="form-group">
                                <label for="attachments">File Pendukung (jpg / pdf)</label>
                                <input type="file" class="form-control-file" id="attachments" @change="getAttachments" multiple v-bind:class="errors.hasOwnProperty('attachments') ? 'is-invalid' : ''">
                                <div class="invalid-feedback" v-if="errors.hasOwnProperty('attachments')">
                                    {{ errors['attachments'][0] }}
                                </div>
                                <small id="emailHelp" class="form-text text-muted" v-else>Maximal size file 2MB.</small>
                            </div>
                            <div class="recaptcha-wrap" v-bind:class="errors.hasOwnProperty('recaptcha') ? 'error' : ''">
                                <vue-recaptcha ref="recaptcha" sitekey="6LewCUwcAAAAAI5TXwwxnMcqc8_c2SANSbkZmNO1" :loadRecaptchaScript=true @verify="handleRecaptcha"></vue-recaptcha>
                                <span>Wajib diisi</span>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Batal</button>
                        <button type="button" class="btn btn-primary" @click="sendMessage">Kirim</button>
                    </div>
                </div>
            </div>
        </div>
    </auth-layout>
</template>

<script>
import axios from "axios";
import moment from "moment";
import $ from "jquery";
import {DataURIToBlob, setAttachments} from "../../UploadHandler";
import SearchArticle from "../../../mobile/components/SearchArticle";

export default {
    name: "Help",
    components: {
        'search-article': SearchArticle,
    },
    data() {
        return {
            data: {},
            search: '',
            loading: true,
            sendLoading: false,
            form: {
                destination: '',
                title: '',
                message: '',
                attachments: []
            },
            destinations: [],
            errors: []
        }
    },
    mounted() {
        this.getData()
    },
    methods: {
        getData (page = 1) {
            const token = this.$cookies.get('token');
            this.loading = true;
            axios.get(`/api/ticket?page=${page}&search=${this.search}`, { headers: {"Authorization" : `Bearer ${token}`} })
                .then((response) => {
                    this.data = response.data;
                    this.loading = false;
                    window.scrollTo(0,0);
                })
                .catch((error) => {

                });
        },
        searchArticle(query) {
            this.search = query;
            this.getData();
        },
        async getDestination () {
            const token = this.$cookies.get('token');
            await axios.get('/api/ticket/destination', { headers: {"Authorization" : `Bearer ${token}`} })
                .then((response) => {
                    this.destinations = response.data
                    $('#sendModal').modal({
                        backdrop: 'static',
                        keyboard: false
                    });
                })
                .catch((error) => {

                });
        },
        moment (date) {
            return moment(date, "YYYY-MM-DD hh:mm:ss").locale('id').format("dddd, D MMMM YYYY HH:mm");
        },
        openModal() {
            this.getDestination()
        },
        sendMessage() {
            const token = this.$cookies.get('token');
            this.errors = [];
            let formData = new FormData();
            this.form.attachments.forEach(file => {
                const item = DataURIToBlob(file)
                formData.append('attachments[]', item);
            });
            formData.append('destination', this.form.destination);
            formData.append('title', this.form.title);
            formData.append('message', this.form.message);
            formData.append('recaptcha', this.form.recaptcha);
            this.sendLoading = true;
            axios.post(`/api/ticket`, formData, { headers: {"Authorization" : `Bearer ${token}`} })
                .then((response) => {
                    this.sendLoading = false;
                    this.$router.push({name: 'help-show', params: {id: response.data.ticket._id}});
                })
                .catch((error) => {
                    if(error.response) {
                        this.$notify({
                            duration: 5000,
                            group: 'main',
                            title: 'Oopppss!',
                            text: error.response.data.message,
                            type: 'warn'
                        })
                        if(error.response.status === 422) {
                            this.errors = error.response.data.errors
                        }
                    }
                    this.sendLoading = false;
                    // Reset recaptcha for load new
                    this.$refs.recaptcha.reset();
                });
        },
        handleRecaptcha(response) {
            if(response) {
                this.form.recaptcha = response
            }
        },
        getAttachments(e) {
            var files = e.target.files;
            const response = setAttachments(files);
            if(response === false) {
                this.$notify({
                    duration: 5000,
                    group: 'main',
                    title: 'Oopppss!',
                    text: "File bukan berupa gambar",
                    type: 'warn'
                });
            } else {
                this.form.attachments = response;
            }
        }
    }

}
</script>

<style scoped>
.open-ticket-wrap {
    padding-bottom: 10px;
}
.wrap-button-ticket {
    display: flex;
    justify-content: space-between;
}
</style>
